import React from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

export default function Landing() {

  return (
    <div className="landing">
      <nav className="landing-nav">
        <span className="landing-nav-logo">String</span>
        <div className="landing-nav-links">
          <Link to="/login">Log In</Link>
          <Link to="/messaging_opt_in" className="landing-nav-cta">Sign Up</Link>
        </div>
      </nav>

      <section className="hero">
        <h1 className="landing-title">Never forget a birthday or anniversary again</h1>
        <p className="landing-subtitle">
          String is a personal reminder service that keeps you thoughtfully connected
          to the people who matter most. Get timely reminders by text or email so you
          always show up on time, with the perfect gift in mind.
        </p>
        <div className="hero-cta">
          <Link to="/messaging_opt_in" className="btn-primary">Get Started Free</Link>
          <Link to="/demo" className="btn-secondary">See How It Works</Link>
        </div>
      </section>

      <section className="how-it-works">
        <h2 className="section-title">How String Works</h2>
        <div className="steps">
          <div className="step">
            <div className="step-number">1</div>
            <h3>Import your contacts</h3>
            <p>Upload your contacts from Apple, iCloud, or Facebook. Select the people whose birthdays and anniversaries you want to track.</p>
          </div>
          <div className="step">
            <div className="step-number">2</div>
            <h3>We send you reminders</h3>
            <p>Get notified at 4 weeks, 2 weeks, 1 week, and day-of via SMS, email, or both. Never be caught off guard again.</p>
          </div>
          <div className="step">
            <div className="step-number">3</div>
            <h3>Stay thoughtful</h3>
            <p>Save gift ideas for each person, track holidays, and manage everything from your dashboard or by texting your String number.</p>
          </div>
        </div>
      </section>

      <section className="features-section">
        <h2 className="section-title">Everything You Need</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">🎂</div>
            <h3>Birthday & Anniversary Tracking</h3>
            <p>Import contacts from vCard, iCloud, or Facebook and never miss a date.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">💬</div>
            <h3>SMS & Email Reminders</h3>
            <p>Choose how you want to be reminded — text message, email, or both.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">🎁</div>
            <h3>Gift Idea Tracker</h3>
            <p>Save gift ideas with links for each person so you're always prepared.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📅</div>
            <h3>Holiday Reminders</h3>
            <p>Valentine's Day, Mother's Day, Father's Day, and Christmas — all included.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📱</div>
            <h3>Text to Add</h3>
            <p>Text your String number to add contacts, gift ideas, or check upcoming events.</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">📆</div>
            <h3>Calendar View</h3>
            <p>See all your events at a glance in list or calendar view from your dashboard.</p>
          </div>
        </div>
      </section>

      <section className="waitlist-section">
        <div className="waitlist-form-wrap">
          <div className="signup-cta-badge">100% Free</div>
          <h2>Start remembering what matters</h2>
          <p>No credit card. No trial period. String is completely free to use — sign up in under two minutes.</p>
          <Link to="/messaging_opt_in" className="cta-button cta-button-large">Create Your Free Account</Link>
          <p className="signup-cta-sub">Already have an account? <Link to="/login">Log in</Link></p>
        </div>
      </section>

      <section className="about-section">
        <h2 className="section-title">About String</h2>
        <p>
          String is a personal event reminder service built for people who care deeply about their
          relationships but need a little help keeping track of the dates that matter. We believe
          that showing up on time with a thoughtful gesture strengthens the bonds that
          make life meaningful.
        </p>
        <p>
          Our name comes from the old tradition of tying a string around your finger to remember
          something important. String does that for you — quietly, reliably, and with a personal touch.
        </p>
      </section>

      <footer className="landing-footer">
        <div className="footer-content">
          <div className="footer-brand">
            <span className="footer-logo">String</span>
            <p>Like tying a string around your finger.</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Product</h4>
              <Link to="/messaging_opt_in">Sign Up</Link>
              <Link to="/login">Log In</Link>
              <Link to="/demo">Demo</Link>
            </div>
            <div className="footer-col">
              <h4>Legal</h4>
              <Link to="/privacy">Privacy Policy</Link>
              <Link to="/terms">Terms of Service</Link>
              <Link to="/messaging_opt_in">SMS Consent</Link>
            </div>
            <div className="footer-col">
              <h4>Contact</h4>
              <a href="mailto:reminders@stringapp.co">reminders@stringapp.co</a>
              <span>Buffalo, NY</span>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} String App. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
